import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=5073e903&scoped=true&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmation.vue?vue&type=style&index=0&id=5073e903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073e903",
  null
  
)

export default component.exports